import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  z-index: 9999999;
  top: ${(p) => p.coordinates.y}px;
  left: ${(p) => p.coordinates.x}px;
  width: ${(p) => (p.width ? `${p.width}px` : 'auto')};
`;
